var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 9.98892C4.83264 8.42947 5.32813 6.90852 6.25097 5.63743C7.17381 4.36633 8.47815 3.40821 9.98278 2.89619C9.92451 2.53881 9.94614 2.17331 10.0462 1.82491C10.1462 1.47651 10.3222 1.1535 10.5621 0.878168C10.802 0.602837 11.1001 0.381737 11.4358 0.230126C11.7715 0.0785143 12.1367 0 12.5064 0C12.8761 0 13.2413 0.0785143 13.577 0.230126C13.9127 0.381737 14.2107 0.602837 14.4506 0.878168C14.6906 1.1535 14.8666 1.47651 14.9666 1.82491C15.0666 2.17331 15.0883 2.53881 15.03 2.89619C16.5322 3.4103 17.8338 4.36933 18.7542 5.64025C19.6747 6.91116 20.1683 8.43098 20.1667 9.98892V17.4945L24 19.9963V21.2472H1V19.9963L4.83333 17.4945V9.98892ZM15.0556 22.4982C15.0556 23.1617 14.7863 23.798 14.3071 24.2672C13.8278 24.7364 13.1778 25 12.5 25C11.8222 25 11.1722 24.7364 10.6929 24.2672C10.2137 23.798 9.94444 23.1617 9.94444 22.4982H15.0556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.0f0855b5ee868b338fca7d6ab884817c.svg";
export { ForwardRef as ReactComponent };